<div class="userbox" fxFlex *ngIf="showUserBox$ | async">
  <div
    *ngIf="!user; else loggedinFlyout"
    fxFlex
    [ngClass]="{
      userbox__nologin: true,
      'userbox__nologin--desktop': !isMobileView,
      'userbox__nologin--mobile': isMobileView
    }"
  >
    <app-account-flyout-context (accountFlyoutClicked)="handleLogin()"></app-account-flyout-context>
  </div>

  <ng-template #loggedinFlyout>
    <ng-container *ngIf="isWebFlyoutEnabled$ | async; else failoverFlyout">
      <cms-user-profile>
        <div>
          <div className="">
            <div slot="user-icon" data-hj-suppress></div>
            <div className="">
              <div slot="user-name" data-hj-suppress></div>

              <div slot="user-business" data-hj-suppress></div>
            </div>
          </div>
        </div>
      </cms-user-profile>
    </ng-container>
    <ng-template #failoverFlyout>
      <ng-container *ngIf="(isWebFlyoutEnabled$ | async) === false">
        <app-account-flyout-failover [user]="user" [isMobileView]="isMobileView"> </app-account-flyout-failover>
      </ng-container>
    </ng-template>
  </ng-template>
  <aside
    *ngIf="isMobile"
    class="account-dropdown"
    [ngClass]="isUserMenuOpened ? 'account-dropdown__open' : 'account-dropdown__close'"
  >
    <app-account-dropdown
      [isMobile]="isMobile"
      [userData]="user"
      (closeSlideMenu)="closeMobileMenu()"
    ></app-account-dropdown>
  </aside>
</div>
<div class="account-dropdown__overlay" *ngIf="isUserMenuOpened"></div>
